import httpService from "./httpService";  
export const sendMail = async (mailData) => {
  try {
    const res = await httpService.post("/send-mail", mailData);
    return res.data;
  } catch (err) {
    console.error("Error sending mail:", err);
    throw err;
  }
};
